import PropTypes from "prop-types";
import React from "react";
import { reduxForm } from "redux-form";
import { useSelector } from "react-redux";
import { saveClaimDocuments } from "../../actions/claimActionsPP";
import { Button, CardSection } from "cxa-components";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { ErrorMessage } from "../common/ErrorMessage";
import DocumentField from "./DocumentField";
import ReferralFieldPP from "./ReferralFieldPP";
import { Prompt } from "react-router-dom";
import { addDays } from "./util";

const AddDocumentsForm = props => {
  const data = useSelector(state => state.claimsPP.documents);
  const error = useSelector(state => state.claimsPP.error);
  const numberOfDaysExpired = useSelector(
    state => state.common.clientSettings.draftClaimExpiresAfterNoDays
  );

  const {
    handleSubmit,
    submitting,
    match: { params },
    intl,
    push,
  } = props;

  const goToPrevious = () => {
    push(
      params.selectedDelegator
        ? `/claims/edit/${params.claimId}/${params.selectedDelegator}`
        : `/claims/edit/${params.claimId}`
    );
  };

  return (
    <form onSubmit={handleSubmit} className="claim-document-form">
      <div>
        {data.uploadReferral && (
          <CardSection>
            <div style={{ maxWidth: "300px" }}>
              <h5>
                <span style={{ color: "red" }}>
                  {data.uploadReferral.isRequired === "Required" && "*"}
                </span>
                <strong>{intl.formatMessage(messages.claims.referralDocument)}</strong>
              </h5>
              <ReferralFieldPP
                {...data.uploadReferral}
                {...props}
                name={data.uploadReferral.fieldId}
                label={
                  Array.isArray(data.uploadReferral.uploadedFiles) &&
                  data.uploadReferral.uploadedFiles.length > 0
                    ? data.uploadReferral.fieldName
                    : ""
                }
              />
            </div>
          </CardSection>
        )}
        {data.uploadSupportingDocuments && (
          <CardSection>
            <h5>
              <strong>{intl.formatMessage(messages.claims.supportingDocuments)}</strong>
            </h5>
            <div className="upload-receipt-container">
              <DocumentField
                {...data.uploadSupportingDocuments}
                name={data.uploadSupportingDocuments.fieldId}
                label={""}
                params={params}
              />
            </div>
          </CardSection>
        )}
      </div>
      {error && <ErrorMessage error={error} intl={intl} />}
      <div
        className="claim-submit-button-container"
        style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Button type="button" disabled={submitting} secondary onClick={goToPrevious}>
          {intl.formatMessage(messages.claims.goPrevious)}
        </Button>
        <Button type="submit" submitting={submitting}>
          {intl.formatMessage(messages.claims.previewButton)}
        </Button>
      </div>
      <Prompt
        when={!submitting}
        message={intl.formatMessage(messages.claims.saveDraftClaimInformationDescription, {
          expiredDate: addDays(numberOfDaysExpired),
        })}
      />
    </form>
  );
};

AddDocumentsForm.propTypes = {
  fields: PropTypes.object,
  handleSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  claimItem: PropTypes.object,
  error: PropTypes.string,
  prisitine: PropTypes.bool,
  submitting: PropTypes.bool,
  intl: intlShape.isRequired,
  change: PropTypes.func,
  changeFieldValue: PropTypes.func,
  onSubmit: PropTypes.func,
  clearSubmitErrors: PropTypes.func,
};

export default injectIntl(
  reduxForm({
    form: "addClaimDocumentsForm",
    onSubmit: saveClaimDocuments,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    forceUnregisterOnUnmount: true,
  })(
    withMatchMediaProps({
      isNarrowScreen: {
        maxWidth: 680,
      },
    })(AddDocumentsForm)
  )
);



// WEBPACK FOOTER //
// ./components/claim/AddDocumentsForm.js